import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { userSettingsApi } from '../api/userSettingsApi.ts';

export const userSettingsKeys = {
  all: ['userSettings'] as const,
  gdprAcknowledgement: () =>
    [...userSettingsKeys.all, 'gdprAcknowledgement'] as const,
  mutations: {
    acknowledgeGdpr: () =>
      [...userSettingsKeys.all, 'mutation', 'acknowledgeGdpr'] as const,
  },
};

export const getGdprAcknowledgementQueryOptions = () =>
  queryOptions({
    queryKey: userSettingsKeys.gdprAcknowledgement(),
    queryFn: () => userSettingsApi.getGdprAcknowledgementAsync(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

/** Compatibility wrapper for incremental migration to query option factories. */
export const useGetGdprAcknowledgementQuery = () =>
  useQuery(getGdprAcknowledgementQueryOptions());

export const useAcknowledgeGdprMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: userSettingsKeys.mutations.acknowledgeGdpr(),
    mutationFn: () => userSettingsApi.acknowledgeGdprAsync(),
    onSuccess: (acknowledgement) => {
      queryClient.setQueryData(
        userSettingsKeys.gdprAcknowledgement(),
        acknowledgement
      );
    },
  });
};
